import React from 'react';

import CircularProgress from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningForm/components/CircularProgress';
import { getActivityTypeColor } from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';
import { precision } from 'scenes/MarketingPlanning/utils';
import { useTheme } from '@gogame/components';

const ProgressBudget = ({ budget, budgetAllocated, activityType }) => {
  const theme = useTheme();
  const progress = React.useMemo(() => {
    return budgetAllocated
      ? precision(Math.min((budgetAllocated / budget) * 100, 100))
      : 0;
  }, [budget, budgetAllocated]);

  const error = budgetAllocated > budget;

  return (
    <CircularProgress
      color={getActivityTypeColor(activityType, theme)}
      progress={progress}
      size={16}
      errorIndicatorSize={6}
      error={error}
    />
  );
};

export default ProgressBudget;
